import styled from 'styled-components';

export const StyledImg = styled.img`
  width: 40px;
  height: 40px;
  margin-bottom: 18px;
`;

export const H3Styled = styled.h3`
  font-family: OpenSans, sans-serif;
  font-style: normal;
  font-weight: normal;
  font-size: 20px;
  line-height: 160%;
  color: ${props => props.theme.colors.darkViolet};
  margin-bottom: 8px;
`;

export const StyledParagraph = styled.p`
  font-family: OpenSans, sans-serif;
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 156%;
  letter-spacing: 0.01em;
  color: #808387;
  word-break: break-word;
`;